module.exports = __webpack_public_path__ + "static/media/p10.9a0e7577.jpeg";